import { useForm } from "react-hook-form";
import Swal from 'sweetalert2';
import { CreateModal } from "../../../shared/components/Modal";
import usePostNotaFiscal from "../hooks/usePostNotaFiscal";
import { NotaFiscalType } from "../types";
import { FormModalNotaFiscal } from "./FormModalNotaFiscal";

interface NotaFiscalModalProps {
  onCancel: () => void;
  visible: boolean;
}

export function NotaFiscalModal({ onCancel, visible }: NotaFiscalModalProps) {
  const { register, handleSubmit, reset, setValue, control, formState: {errors}} = useForm<NotaFiscalType>();

  const { mutate: salvarNotaFiscal, isLoading: LoadingButton} = usePostNotaFiscal(() => handleCloseLaterSave());

  async function onSubmit(data: NotaFiscalType) {
    const formattedData = {
      ...data,
      NotaFiscalData: data.NotaFiscalData.split("/").reverse().join("-"),
      ComissaoPorcentagem: data.ComissaoPorcentagem
      ? data.ComissaoPorcentagem / 100
      : 0,
    };
    
    navigator.onLine &&
      await salvarNotaFiscal(formattedData);

    if(!navigator.onLine) {
      Swal.fire({
        title: 'Sem conexão',
        text: 'Por favor, verifique a sua conexão com a internet e tente novamente.',
        icon: 'error',
        position: 'center',
        confirmButtonText: 'OK',
        confirmButtonColor: '#f27474'
      })
    }
  }

  function handleCloseLaterSave() {
    onCancel();
    reset();
  }

  return (
    <>
      <CreateModal
        title="Cadastrar Nota Fiscal"
        isModalOpen={visible}
        onCancel={onCancel}
        onSubmit={handleSubmit(onSubmit)}
        isLoading={LoadingButton}
        >
        <FormModalNotaFiscal
          register={register}
          setValue={setValue}
          control={control}
          errors={errors}
          />
      </CreateModal>
    </>
  );
}
